'use client';

import { useTranslation } from 'next-i18next';

/**
 * @description Offer Page Title
 */
export const OfferPageTitle = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <h1 className="relative my-10 text-center text-4xl font-bold">{t('offer.page.heading.title')}</h1>
    </>
  );
};
